<template>
  <div>
    <el-table
        :data="tableData"
        ref="table"
        v-loading="loading"
        size="mini"
        style="width: 100%;padding-top:10px;"
        max-height="454px"
        height="300px"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="prjNo"
          :label="$l('project_table_label_no')||'项目编号'"
          min-width="100"
      >
      </el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="prjTitle"
          :label="$l('project_table_label_name')||'项目名称'"
          min-width="120"
      >
      </el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="prjCategoryName"
          :label="$l('project_table_label_category')||'项目分类'"
          min-width="120"
      >
      </el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="custName"
          :label="$l('project_table_label_customer')||'客户'"
          min-width="120"
      >
      </el-table-column>
      <el-table-column
          :label="$l('table_head_operation') || '操作'"
          width="130"
          align="center"
      >
        <template slot-scope="scope">
          <el-button @click="joinProject(scope.row)" type="success" size="small">
            {{$l('project_btn_join_prj')||'加入项目'}}
          </el-button>
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
        </div>
      </div>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => []
    },
    productList: {
      default: () => []
    },
    type: {
      default: '',
      type:String
    },
    loading: {
      default: false
    }
  },
  components: {
  },
  data () {
    return {
      currentRow: null
    }
  },
  watch: {
    productList: {
      handler () {
      }
    }
  },
  methods: {
    joinProject (row) {
      this.save(row)
    },
    save (row) {
      let param = {
        prjCode: row.prjCode,
        productList: this.productList
      }
      this.$confirm(
          this.$l('project_tips_select_question') + `【${row.prjTitle}】？` || `是否确认加入该【${row.prjTitle}】项目？`,
          this.$l("INDEX.tips_question_title") || "提示",
          {
              confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
              cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
              type: "warning",
          }
      ).then(() => {
          if (this.type === 'selection') {
              this.$api.addInfoProductApi(param).then(() => {
                  this.$message.success(this.$l('INDEX.tips_save_ok')||'保存成功')
                  // 通知父组件保存成功
                  this.$emit('success')
              })
          }else if (this.type === 'recommend') {
              this.$api.buildRecommendFromCartOrCollectApi(param).then(() => {
                  this.$message.success(this.$l('INDEX.tips_save_ok')||'保存成功')
                  this.$emit('success')
              })
          }else if (this.type === 'quotation') {
              this.$api.buildQuotationFromCartOrCollectApi(param).then(() => {
                  this.$message.success(this.$l('INDEX.tips_save_ok')||'保存成功')
                  this.$emit('success')
              })
          }
      })
    }
  }
}
</script>
